<script lang="ts" setup>
import { ref } from 'vue'
const props = defineProps({
    title: {
        type: String,
        required: true
    },
    to: {
        type: [String, Object],
        required: true
    },
    img: {
        type: String,
        required: true
    }
})
</script>
<template>
    <router-link :to="to" class="category">
        <div class="category-img">
            <img :src="img" :alt="title" />
        </div>
        <div class="category-title">
            <h3>{{ title }}</h3>
        </div>
    </router-link>
</template>
<style lang="scss" scoped>
.category{
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-decoration: none;
    width: 308px;
    height: 278px;
    padding: 10px;
    color: #000;
    background: #FFFFFF;
    box-shadow: 0px 0px 8px 0px #00000040;
    border-radius: 11px;
    z-index: 1;
    &:after{
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 8px;
        width: 100%;
        border-radius: 0px 0px 11px 11px;
        content:'';
        background-color: #F52B2B;
        z-index: 2;
        
    }
    &:hover{
        // we change the shadow color on hover
        box-shadow: 0px 0px 12px 0px #000000CC;
    }
    .category-img{
        width: 100%;
        img{
            width: 100%;
            height: 170px;
            object-fit: contain;

        }
    }
    .category-title{
        width: 100%;
        height: calc(100% - 170px);
        display: flex;
        justify-content: center;
        align-items: center;
        h3{
            text-align: center;
            margin: 0;
        }
    }
}
</style>